module.exports = __webpack_public_path__ + "static/media/news-8.1acd7b16.jpg";